module.exports = __webpack_public_path__ + "static/06-interdependence-6ee6c9720c486a29618387694012a1b9.png";